// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","profile":"header_profile__JMpln","secondaryheader":"header_secondaryheader__PdEC3"};